module.exports = __webpack_public_path__ + "img/hoang.199483ab.jpeg";